import { StringWithLocaleDto } from '@api/dtos';
import { observer } from 'mobx-react';
import * as React from 'react';
import { Markdown } from '../markdown';

import './header.scss';
import { findDisplayValue } from '../../core/multi-language';

interface HeaderProps {
    children?: React.ReactNode;
    headline?: string;
    headlines?: StringWithLocaleDto[];
    description?: string;
    descriptions?: StringWithLocaleDto[];
    backgroundImage?: string;
}

export const Header = observer((props: HeaderProps) => {
    const { children, backgroundImage, headlines, descriptions } = props;
    const imageStyle = backgroundImage
        ? {
              backgroundImage: `url(${backgroundImage})`
          }
        : undefined;
    const description = findDisplayValue(descriptions);

    return (
        <header className="header">
            <div className="header__teaser-background" style={imageStyle} />
            <h1
                className={classnames('header__h1', {
                    'header__h1--with-description': description
                })}
            >
                <Markdown noParagraph>{findDisplayValue(headlines)}</Markdown>
            </h1>
            {description && (
                <div className="header__description">{description}</div>
            )}
            {children}
        </header>
    );
});
